(function() {
    const caseStudiesElements = document.querySelectorAll('.case-studies');

    caseStudiesElements.forEach(function(caseStudiesElement) {
        const $class = 'case-studies';
        const swiperCarousel = new Swiper(`.${$class}__carousel`, {
            wrapperClass: `${$class}__ribbon`,
            slideClass: `${$class}__case`,
            direction: 'horizontal',
            loop: true,
            speed: 600,
            navigation: {
                prevEl: `.${$class}__controller--left`,
                nextEl: `.${$class}__controller--right`,
            },
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            on: {
                init: function() {
                    caseStudiesElement.querySelector(`.${$class}__carousel`).classList.add(`${$class}__carousel--active`);
                }
            }
        });
    });
})();
